/**
 * Which of the store's purchases a personal Restore Purchases confirms (#6242).
 *
 * The pick goes by product, never by position. Neither Google Play nor StoreKit
 * promises an order for the purchases a device holds, and a device can also hold a
 * coach-tier subscription. The personal confirmation endpoints do not check the
 * product, so a coach-tier purchase sent there would be recorded as the user's
 * personal Premium.
 *
 * Kept free of Angular and Capacitor, like `store-purchase-flow.ts`, so the choice
 * can be unit-tested without a device or a store.
 */

export interface PersonalRestorePick<T> {
  /** the purchase to confirm, or undefined when the store holds none of ours */
  chosen: T | undefined;
  /** how many of the store's purchases were personal ones */
  personalCount: number;
}

export function pickPersonalRestorePurchase<T extends { productId: string }>(
  purchases: readonly T[],
  personalProductIds: readonly string[],
): PersonalRestorePick<T> {
  // keep the store's order among our own products; the caller reports it when
  // there is more than one, because neither store should ever hand us two
  const personal = purchases.filter(p => personalProductIds.includes(p.productId));
  return { chosen: personal[0], personalCount: personal.length };
}
